import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';
import Swal from 'sweetalert2';
declare var $ :any;

@Component({
  selector: 'app-mebankusers',
  templateUrl: './mebankusers.component.html'
})
export class MebankusersComponent implements OnInit {

  model: any = {};
  activateModel: any = {};
  showActivateOptions: boolean = false;
  alreadyActive: boolean = false;
  lastCheckedUsername: string = '';
  datalist: Array<Object> = [];
  getmebankusersRestApiUrl: string = AppSettings.getmebankusers;
  updatemebankuserRestApiUrl: string = AppSettings.updatemebankuser;
  getmebankuserbyusernameRestApiUrl: string = AppSettings.getmebankuserbyusername;

  constructor(
    private loginService: LoginService,
    private CommonService: CommonService,
    private router: Router,
    private http: Http) {
      document.body.className = "theme-red";
  }

  ngOnInit() {
    this.loginService.localStorageData();
    this.loginService.viewsActivate();
    this.model.usergroup = localStorage.getItem('currentUsergroup');
    if (this.model.usergroup == 2) {
      this.loginService.logout();
      return;
    }
    if (this.model.usergroup != 1) {
      this.router.navigate(['/admindashboard']);
      return;
    }
    this.loadMebankusers();
  }

  loadMebankusers() {
    this.CommonService.getdata(this.getmebankusersRestApiUrl)
    .subscribe(userdet => {
        if (userdet.result != "") {
          this.datalist = Object.values(userdet.result);
          this.loginService.viewCommontdataTable('dataTable', 'mebankuser_table');
        } else {
          this.datalist = [];
        }
    });
  }

  logout() {
    this.loginService.logout();
  }

  onActivateUsernameChange() {
    let username = (this.activateModel.username || '').trim();
    if (username == this.lastCheckedUsername) {
      return;
    }
    this.showActivateOptions = false;
    this.alreadyActive = false;
    this.activateModel.Id = '';
  }

  checkActivateUser() {
    let username = (this.activateModel.username || '').trim();
    if (username == '') {
      this.showActivateOptions = false;
      this.lastCheckedUsername = '';
      Swal.fire('Oops...', 'Enter username', 'error');
      return;
    }
    this.CommonService.checkexistdata(this.getmebankuserbyusernameRestApiUrl, {username: username})
    .subscribe(data => {
      if (data.exist == 1) {
        this.showActivateOptions = true;
        this.alreadyActive = data.already_active == 1;
        this.lastCheckedUsername = data.result.username;
        this.activateModel.Id = data.result.Id;
        this.activateModel.username = data.result.username;
        this.activateModel.mebankshow = Number(data.result.mebankshow);
        this.activateModel.mebankstatus = Number(data.result.mebankstatus);
        if (isNaN(this.activateModel.mebankshow)) {
          this.activateModel.mebankshow = 1;
        }
        if (isNaN(this.activateModel.mebankstatus)) {
          this.activateModel.mebankstatus = 1;
        }
      } else {
        this.showActivateOptions = false;
        this.alreadyActive = false;
        this.lastCheckedUsername = '';
        this.activateModel.Id = '';
        this.activateModel.mebankshow = '';
        this.activateModel.mebankstatus = '';
        Swal.fire('Oops...', data.message || 'User does not exist', 'error');
      }
    });
  }

  cancelActivateUser() {
    this.showActivateOptions = false;
    this.alreadyActive = false;
    this.lastCheckedUsername = '';
    this.activateModel = {};
  }

  updateActivateUser() {
    if (!this.activateModel.Id) {
      Swal.fire('Oops...', 'Check username first', 'error');
      return;
    }
    let updateData = {
      Id: this.activateModel.Id,
      mebankshow: this.activateModel.mebankshow,
      mebankstatus: this.activateModel.mebankstatus
    };
    this.CommonService.updatedata(this.updatemebankuserRestApiUrl, updateData)
    .subscribe(package_det => {
         Swal.fire(
          package_det.status,
          package_det.message,
          package_det.status == 'success' ? 'success' : 'error'
        );
         if (package_det.status == 'success') {
           this.alreadyActive = this.activateModel.mebankstatus == 1;
           if ($.fn.DataTable.isDataTable('#dataTable')) {
             $('#dataTable').DataTable().destroy();
           }
           this.loadMebankusers();
         }
    });
  }

  edituser(item: any) {
    this.model.Id = item.Id;
    this.model.username = item.username;
    this.model.mebankshow = Number(item.mebankshow);
    this.model.mebankstatus = Number(item.mebankstatus);
    $('#mebankUserModal').modal('show');
  }

  updateuser() {
    let updateData = {
      Id: this.model.Id,
      mebankshow: this.model.mebankshow,
      mebankstatus: this.model.mebankstatus
    };
    this.CommonService.updatedata(this.updatemebankuserRestApiUrl, updateData)
    .subscribe(package_det => {
         Swal.fire(
          package_det.status,
          package_det.message,
          package_det.status == 'success' ? 'success' : 'error'
        );
         $('#mebankUserModal').modal('hide');
         if ($.fn.DataTable.isDataTable('#dataTable')) {
           $('#dataTable').DataTable().destroy();
         }
         this.loadMebankusers();
    });
  }
}
